import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/MainPage";
import AboutUs from "../pages/AboutUs";
import Properties from "../pages/Properties";
import Payments from "../pages/Payments";
import PaymentMethod from "../pages/PaymentMethod";
import ServicesPage from "../pages/ServicesPage";
import Contact from "../pages/ContactPage";
import PropertiesView from "../pages/PropertiesView";
import NotFound from "../pages/config-pages/NotFound";
import RegisterYourProperty from "../pages/RegisterYourPropertyPage";
import PropertiesViewEdit from "../pages/PropertiesViewEdit";
import RootLayout from "../layout/RootLayout";
import SignInPage from "../pages/SignInPage";
import OtpPage from "../pages/OtpPage";
import AuthLayout from "../layout/AuthLayout";
import Redirect from "../pages/Redirect";
import SignUpPage from "../pages/SignUpPage";
import Transactions from '../pages/Transactions'

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { path: "/sign-in", element: <SignInPage /> },
      { path: "/sign-in-otp", element: <OtpPage /> },
      { path: "/sign-up", element: <SignUpPage /> },
      { path: "*", element: <NotFound /> },

      { path: "/", element: <Properties /> },
      { path: "/nosotros", element: <AboutUs /> },
      { path: "/propiedades", element: <Properties /> },
      { path: "/propiedades/:slug", element: <PropertiesView /> },

      { path: "/servicios", element: <ServicesPage /> },
      { path: "/contactanos", element: <Contact /> },
      { path: "/redirect", element: <Redirect /> },
      {
        element: <AuthLayout />,
        children: [
          { path: "/transacciónes", element: <Transactions /> }, 
          { path: "/", element: <Properties /> },
          { path: "/propiedades-edit/:slug", element: <PropertiesViewEdit /> },
          { path: "/registra-tu-propiedad", element: <RegisterYourProperty /> },
          { path: "/payments", element: <Payments /> },
          { path: "/payments/method", element: <PaymentMethod /> },
        ],
      },
    ],
  },
]);

export default router;
